import DoctorProfileComponent from '../components/doctors/DoctorProfileComponent';

function DoctorProfile() {
  return <DoctorProfileComponent />;
}

export default DoctorProfile;
